import { useCallback, useState } from 'react';

export type UseModalResult = {
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

export function useModal(): UseModalResult {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  return {
    isModalOpen,
    openModal,
    closeModal,
  };
}
